
export default function ParkInfoSection() {
  const entryFees = [
    {
      category: 'Nacionales',
      weekday: '$35.000',
      weekend: '$41.000',
      icon: 'ri-user-line'
    },
    {
      category: 'Extranjeros',
      weekday: '$77.500',
      weekend: '$92.000',
      icon: 'ri-global-line'
    },
    {
      category: 'Vehículos',
      weekday: '$14.500',
      weekend: '$20.000',
      icon: 'ri-car-line'
    }
  ];

  const recommendations = [
    {
      icon: 'ri-shield-check-line',
      title: 'Seguro Médico',
      description: 'Obligatorio para el ingreso al parque'
    },
    {
      icon: 'ri-sun-line',
      title: 'Protector Solar',
      description: 'Solo biodegradable, protege el ecosistema'
    },
    {
      icon: 'ri-t-shirt-line',
      title: 'Calzado Cómodo',
      description: 'Para caminar por senderos naturales'
    },
    {
      icon: 'ri-delete-bin-line',
      title: 'Sin Plásticos',
      description: 'Prohibido ingresar plásticos e icopor'
    }
  ];

  return (
    <section id="parque" className="py-20 bg-gradient-to-b from-emerald-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
            Planifica Tu Visita
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Información esencial para disfrutar al máximo tu experiencia en el Parque Tayrona
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Tarifas de Ingreso */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <div className="bg-emerald-600 text-white p-6">
              <h3 className="text-2xl font-bold mb-2">
                <i className="ri-ticket-line mr-2"></i>
                Tarifas de Ingreso 2025
              </h3>
              <p className="text-emerald-100">Valores aproximados sujetos a PNN</p>
            </div>
            <div className="p-6">
              <div className="space-y-4">
                {/* Nacionales */}
                <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                  <div className="flex items-center">
                    <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-user-line text-emerald-600"></i>
                    </div>
                    <span className="font-semibold text-gray-800">Nacionales</span>
                  </div>
                  <div className="text-right">
                    <div className="text-sm text-gray-600">Temporada baja</div>
                    <div className="font-bold text-emerald-600">$35.000</div>
                    <div className="text-sm text-gray-600">Temporada alta y festivos</div>
                    <div className="font-bold text-emerald-600">$41.000</div>
                  </div>
                </div>

                {/* Extranjeros */}
                <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                  <div className="flex items-center">
                    <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-global-line text-emerald-600"></i>
                    </div>
                    <span className="font-semibold text-gray-800">Extranjeros</span>
                  </div>
                  <div className="text-right">
                    <div className="text-sm text-gray-600">Temporada baja</div>
                    <div className="font-bold text-emerald-600">$77.500</div>
                    <div className="text-sm text-gray-600">Temporada alta y festivos</div>
                    <div className="font-bold text-emerald-600">$92.000</div>
                  </div>
                </div>

                {/* Edad 5 - 25 años */}
                <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                  <div className="flex items-center">
                    <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-user-star-line text-emerald-600"></i>
                    </div>
                    <span className="font-semibold text-gray-800">Edad 5 - 25 años</span>
                  </div>
                  <div className="text-right">
                    <div className="text-sm text-gray-600">Temporada baja</div>
                    <div className="font-bold text-emerald-600">$26.000</div>
                    <div className="text-sm text-gray-600">Temporada alta y festivos</div>
                    <div className="font-bold text-emerald-600">$29.000</div>
                  </div>
                </div>

                {/* Seguro Médico Obligatorio */}
                <div className="flex items-center justify-between p-4 bg-red-50 rounded-lg border-2 border-red-200">
                  <div className="flex items-center">
                    <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-shield-cross-line text-red-600"></i>
                    </div>
                    <span className="font-semibold text-gray-800">Seguro Médico Obligatorio</span>
                  </div>
                  <div className="text-right">
                    <div className="text-sm text-gray-600">Por día y persona</div>
                    <div className="font-bold text-red-600">$7.000</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Nueva sección: Tarifas de Ingreso para Vehículos */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <div className="bg-blue-600 text-white p-6">
              <h3 className="text-2xl font-bold mb-2">
                <i className="ri-car-line mr-2"></i>
                Tarifas de Ingreso para Vehículos
              </h3>
              <p className="text-blue-100">Clasificación por tipo de vehículo</p>
            </div>
            <div className="p-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {/* Automóvil */}
                <div className="text-center p-6 bg-blue-50 rounded-lg border-2 border-blue-200">
                  <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-car-line text-2xl text-white"></i>
                  </div>
                  <h4 className="font-bold text-blue-800 mb-2">Automóvil</h4>
                  <p className="text-2xl font-bold text-blue-600 mb-1">$20.000</p>
                  <p className="text-sm text-blue-700">Vehículos particulares</p>
                </div>

                {/* Colectivo (Vans) */}
                <div className="text-center p-6 bg-purple-50 rounded-lg border-2 border-purple-200">
                  <div className="w-16 h-16 bg-purple-500 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-truck-line text-2xl text-white"></i>
                  </div>
                  <h4 className="font-bold text-purple-800 mb-2">Colectivo (Vans)</h4>
                  <p className="text-2xl font-bold text-purple-600 mb-1">$51.500</p>
                  <p className="text-sm text-purple-700">Vehículos de transporte público</p>
                </div>

                {/* Bus o Buseta */}
                <div className="text-center p-6 bg-orange-50 rounded-lg border-2 border-orange-200">
                  <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-bus-line text-2xl text-white"></i>
                  </div>
                  <h4 className="font-bold text-orange-800 mb-2">Bus o Buseta</h4>
                  <p className="text-2xl font-bold text-orange-600 mb-1">$108.500</p>
                  <p className="text-sm text-orange-700">Buses de gran capacidad</p>
                </div>

                {/* Motocicleta */}
                <div className="text-center p-6 bg-teal-50 rounded-lg border-2 border-teal-200">
                  <div className="w-16 h-16 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-motorbike-line text-2xl text-white"></i>
                  </div>
                  <h4 className="font-bold text-teal-800 mb-2">Motocicleta</h4>
                  <p className="text-2xl font-bold text-teal-600 mb-1">$14.500</p>
                  <p className="text-sm text-teal-700">Motocicletas y motonetas</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Horarios - ahora en una sección separada */}
        <div className="mt-12 bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="bg-amber-600 text-white p-6">
            <h3 className="text-2xl font-bold mb-2">
              <i className="ri-time-line mr-2"></i>
              Horarios El Zaino
            </h3>
            <p className="text-amber-100">Entrada principal al parque</p>
          </div>
          <div className="p-6">
            <div className="space-y-6">
              {/* Horarios de Ingreso */}
              <div className="text-center p-6 bg-green-50 rounded-lg border-2 border-green-200">
                <h4 className="font-bold text-green-800 mb-3">
                  <i className="ri-login-circle-line mr-2"></i>
                  Horarios de Ingreso
                </h4>
                <div className="space-y-3">
                  <div>
                    <p className="text-sm font-semibold text-green-700 mb-1">Temporada Alta</p>
                    <p className="text-xl font-bold text-green-600">7:00 AM - 3:00 PM</p>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-green-700 mb-1">Temporada Baja</p>
                    <p className="text-xl font-bold text-green-600">8:00 AM - 5:00 PM</p>
                  </div>
                </div>
              </div>

              {/* Aviso importante */}
              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <i className="ri-alert-line text-yellow-400 text-xl"></i>
                  </div>
                  <div className="ml-3">
                    <h5 className="text-sm font-bold text-yellow-800 mb-2">IMPORTANTE:</h5>
                    <div className="text-sm text-yellow-700 space-y-1">
                      <p>• Por favor estar ANTES del horario de cierre para evitar complicaciones al ingresar</p>
                      <p>• Si tienes pensado llegar tarde, háznolo saber con anterioridad</p>
                      <p>• No nos hacemos responsables si no dan aviso y llegan tarde</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Recomendaciones */}
        <div className="mt-12 bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="bg-teal-600 text-white p-6">
            <h3 className="text-2xl font-bold mb-2">
              <i className="ri-lightbulb-line mr-2"></i>
              Recomendaciones Importantes
            </h3>
            <p className="text-teal-100">Para una experiencia segura y responsable</p>
          </div>
          
          <div className="p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {recommendations.map((rec, index) => (
                <div key={index} className="text-center p-4 bg-gray-50 rounded-lg hover:bg-teal-50 transition-colors">
                  <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className={`${rec.icon} text-xl text-teal-600`}></i>
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-2">{rec.title}</h4>
                  <p className="text-sm text-gray-600">{rec.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
